export const FETCH_SALE_TYPES = 'SaleTypes/FETCH_SALE_TYPES'
export const FETCH_SALE_TYPES_SUCCESS = 'SaleTypes/FETCH_SALE_TYPES_SUCCESS'
export const FETCH_SALE_TYPES_ERROR = 'SaleTypes/FETCH_SALE_TYPES_ERROR'
export const FETCH_SALE_TYPES_DONE = 'SaleTypes/FETCH_SALE_TYPES_DONE'
